import { action } from 'mobx';
import { ShipmentInfoService } from 'common/data';
import { BaseStore } from 'core/stores';

class ShipmentInfoStore extends BaseStore {
	constructor(rootStore) {
		super(new ShipmentInfoService(rootStore.app.baasic.apiClient));
	}

	@action
	getShipmentInfo = async (id, options) => {
		const shipmentInfo = await this.service.get(id, options);
		this.item = shipmentInfo.data;
	};

	// Old labeling mode.
	@action
	getFulfillmentOrderShipment = async (upc, sourceOfChange) => {
		const response = await this.service.getFulfillmentOrderShipment(upc, sourceOfChange);
		this.response = response.data;
	};

	// New labeling mode.
	@action
	createOrGetShipment = async (createOrGetShipmentParams, sourceOfChange) => {
		const response = await this.service.createOrGetShipment(createOrGetShipmentParams, sourceOfChange);
		this.response = response.data;
	};

	@action
	removeFromPallet = async requestContent => {
		const response = await this.service.removeFromPallet(requestContent);
		this.response = response;
		return response.data;
	};

	@action
	exportLabels = async (carrierTypeId, serviceTypeId, dateTime) => {
		const response = await this.service.exportLabels(carrierTypeId, serviceTypeId, dateTime);
		this.item = response;
		return response;
	};

	@action.bound
	scanTrackingNumber = async requestContent => {
		const response = await this.service.scanTrackingNumber(requestContent);
		this.item = response;
		return response.data;
	};

	@action
	bulkPrint = async (bulkPrintFulfillmentOrders, sourceOfChange) => {
		const response = await this.service.bulkPrint(bulkPrintFulfillmentOrders, sourceOfChange);
		this.item = response;
	};

	@action
	updateShipmentInfo = async (shipmentInfo, revertFulfillmentOrderStatus = false, sourceOfChange) => {
		await this.service.updateShipmentInfo(shipmentInfo, revertFulfillmentOrderStatus, sourceOfChange);
	};

	@action
	updateShipmentInfoByTrackingNumber = async (shipmentInfo, sourceOfChange) => {
		await this.service.updateShipmentInfoByTrackingNumber(shipmentInfo, sourceOfChange);
	};

	@action
	undoPalletize = async (scanParams, sourceOfChange) => {
		await this.service.undoPalletize(scanParams, sourceOfChange);
	};

	@action
	reprintLabel = async (shipmentInfoId, getLabel = false) => {
		const response = await this.service.reprintLabel(shipmentInfoId, getLabel);
		this.item = response;
		return this.item;
	};

	@action
	deleteShipmentInfo = async shipmentInfo => {
		shipmentInfo = { id: shipmentInfo.id };
		await this.service.delete(shipmentInfo);
	};

	@action
	voidLabel = async (voidLabelParams, voidOption, sourceOfChange) => {
		const response = await this.service.voidLabel(voidLabelParams, voidOption, sourceOfChange);
		this.item = response;
		return this.item.data;
	};

	@action
	undoLabelCreated = async (undoLabelCreatedParams, sourceOfChange) => {
		const response = await this.service.undoLabelCreated(undoLabelCreatedParams, sourceOfChange);
		this.item = response;
		return this.item.data;
	};

	@action
	createReturnLabel = async returnLabelParams => {
		const response = await this.service.createReturnLabel(returnLabelParams);
		this.item = response;
		return this.item.data;
	};
}

export default ShipmentInfoStore;



// WEBPACK FOOTER //
// ./src/modules/shipment-info/stores/ShipmentInfoStore.js